import { PERMISSIONS } from '../permissions';

const RouterView = {template: '<router-view />'};

// Container
const DefaultContainer = () => import('../UI/DefaultContainer');
// Pages
const Login = () => import('../UI/pages/Login');
const VerifyAccount = () => import('../UI/pages/VerifyAccount');
const Dashboard = () => import('../UI/pages/Dashboard');
const Customers = () => import('../UI/pages/Customers');
const ChangePassword = () => import('../UI/pages/ChangePassword');
const NotAllowed = () => import('../UI/pages/NotAllowed');
const NotVerified = () => import('../UI/pages/NotVerified');
const RoleNotApproved = () => import('../UI/pages/RoleNotApproved');
const UserProfile = () => import('../UI/pages/UserProfile');
const SavingsReport = () => import('../UI/pages/SavingsReport');
const UserAccess = () => import('../UI/pages/UserAccess');
const StaffUsers = () => import('../UI/pages/UserAccess/StaffUsers');
const AddStaffUser = () => import('../UI/pages/UserAccess/StaffUsers/Add');
const EditStaffUser = () => import('../UI/pages/UserAccess/StaffUsers/Edit');
const Roles = () => import('../UI/pages/UserAccess/Roles');
const AddRole = () => import('../UI/pages/UserAccess/Roles/Add');
const EditRole = () => import('../UI/pages/UserAccess/Roles/Edit');
const ManagePermissions = () => import('../UI/pages/UserAccess/Roles/ManagePermissions');
const DeleteRole = () => import('../UI/pages/UserAccess/Roles/Delete');
const Transactions = () => import('../UI/pages/Transactions');
const AddTransaction = () => import('../UI/pages/Transactions/Add');
const Deposits = () => import('../UI/pages/Deposits');
const Withdraws = () => import('../UI/pages/Withdraws');
const AddDeposit = () => import('../UI/pages/Deposits/Add');

// const BankTransactions = () => import('../UI/pages/BankTransactions');
// const AddBankTransaction = () => import('../UI/pages/BankTransactions/Add');
const Reconcilliation = () => import('../UI/pages/Reconcilliation');
const BankBalances = () => import('../UI/pages/BankBalances');
const AddBankBalance = () => import('../UI/pages/BankBalances/Add');
const AuditTrail = () => import('../UI/pages/AuditTrail');
const Configurations = () => import('../UI/pages/Configurations');
const GeneralConfigs = () => import('../UI/pages/Configurations/General');
const EditGeneralConfig = () => import('../UI/pages/Configurations/General/Edit');
const SupportedBanks = () => import('../UI/pages/Configurations/SupportedBanks');
const EditBankDetails = () => import('../UI/pages/Configurations/SupportedBanks/Edit');
const AddSupportedBank = () => import('../UI/pages/Configurations/SupportedBanks/Add');

const FinlinkAccounts = () => import('../UI/pages/FinlinkAccounts');
const FinlinkAccountDetail = () => import('../UI/pages/FinlinkAccounts/Detail');

const LoanApplications = () => import('../UI/pages/LoanApplications');
const LoanApplicationDetail = () => import('../UI/pages/LoanApplications/Detail');
const RejectLoanApplication = () => import('../UI/pages/LoanApplications/Reject');
const BroadcastLoanApplication = () => import('../UI/pages/LoanApplications/Broadcast');

const Reminders = () => import('../UI/pages/Reminders/List');
const AddReminder = () => import('../UI/pages/Reminders/Add');
const EditReminder = () => import('../UI/pages/Reminders/Edit');
const ConfirmDeleteReminder = () => import('../UI/pages/Reminders/ConfirmDelete');

export default [
  {
    path: '/',
    name: 'Finlink',
    redirect: '/dashboard',
    component: DefaultContainer,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          permissions: []
        }
      },
      {
        path: 'customers',
        name: 'Customers',
        component: Customers,
        meta: {
          permissions: []
        }
      },
      {
        path: 'finlinkAccounts',
        name: 'Finlink Accounts',
        // redirect: '/finlinkAccounts/list',
        component: FinlinkAccounts,
        meta: {
          permissions: [
            
          ]
        },
        children: [
          // {
          //   path: 'list',
          //   name: 'List',
          //   component: FinlinkAccounts,
          //   meta: {
          //     permissions: [
                
          //     ]
          //   }
          // },
          {
            path: ':accountId/',
            name: 'Detail',
            component: FinlinkAccountDetail,
            props: true,
            meta: {
              permissions: [
                
              ]
            }
          }
        ]
      },
      {
        path: 'loanApplications',
        name: 'Loan Applications',
        component: LoanApplications,
        meta: {
          permissions: [
            PERMISSIONS.VIEW_LOANS
          ]
        },
        children: [
          {
            path: ':loanApplicationId/',
            name: 'Loan Application Detail',
            component: LoanApplicationDetail,
            props: true,
            meta: {
              permissions: [
                // PERMISSIONS.VIEW_LOANS
              ]
            }
          },
          {
            path: ':loanApplicationId/reject',
            name: 'Reject Loan Application',
            component: RejectLoanApplication,
            props: true,
            meta: {
              permissions: [
                PERMISSIONS.REJECT_LOANS
              ]
            }
          },
          {
            path: ':loanApplicationId/broadcast',
            name: 'Broadcast Loan Application',
            component: BroadcastLoanApplication,
            props: true,
            meta: {
              permissions: [
                PERMISSIONS.BROADCAST_LOANS
              ]
            }
          }
        ]
      },
      {
        path: 'configurations',
        redirect: '/configurations/general',
        name: 'Configurations',
        component: Configurations,
        children: [
          {
            path: 'general',
            name: 'General',
            component: GeneralConfigs,
            meta: {
              permissions: [
                PERMISSIONS.READ_CONFIGURATIONS
              ]
            },
            children: [
              {
                path: ':configName/edit',
                name: 'Edit General Config',
                component: EditGeneralConfig,
                props: true,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_CONFIGURATIONS
                  ]
                }
              }
            ]
          },
          {
            path: 'supportedBanks',
            name: 'Supported Banks',
            component: SupportedBanks,
            meta: {
              permissions: [
                PERMISSIONS.READ_CONFIGURATIONS
              ]
            },
            children: [
              {
                path: 'add',
                name: 'Add Supported Bank',
                component: AddSupportedBank,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_CONFIGURATIONS
                  ]
                }
              },
              {
                path: ':bankId/edit',
                name: 'Edit Bank Details',
                component: EditBankDetails,
                props: true,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_CONFIGURATIONS
                  ]
                }
              }
            ]
          }
        ]
      },
      {
        path: 'users/:userId',
        name: 'User Profile',
        component: UserProfile,
        props: true,
        meta: {
          permissions: []
        }
      },
      {
        path: 'savingsReport',
        name: 'Savings Report',
        component: SavingsReport,
        meta: {
          permissions: []
        }
      },
      {
        path: 'transactions',
        name: 'Transactions',
        component: Transactions,
        meta: {
          permissions: [
            PERMISSIONS.READ_TRANSACTIONS
          ]
        },
        children: [
          {
            path: 'add',
            name: 'Record Transaction',
            component: AddTransaction,
            meta: {
              permissions: [
                PERMISSIONS.TRANSACTION_MAKER
              ]
            }
          }
        ]
      },
      {
        path: 'deposits',
        name: 'Investments',
        component: Deposits,
        meta: {
          permissions: [
            PERMISSIONS.READ_TRANSACTIONS
          ]
        },
        children: [
          {
            path: 'add',
            name: 'Record Investment',
            component: AddDeposit,
            meta: {
              permissions: [
                PERMISSIONS.TRANSACTION_MAKER
              ]
            }
          }
        ]
      },
      {
        path: 'withdraws',
        name: 'Withdraws',
        component: Withdraws,
        meta: {
          permissions: [
            PERMISSIONS.READ_TRANSACTIONS
          ]
        }
      },
      // {
      //   path: 'bankTransactions',
      //   name: 'Bank Transactions',
      //   component: BankTransactions,
      //   meta: {
      //     permissions: [
      //       PERMISSIONS.READ_BANK_TRANSACTIONS
      //     ]
      //   },
      //   children: [
      //     {
      //       path: 'add',
      //       name: 'Record Bank Transaction',
      //       component: AddBankTransaction,
      //       meta: {
      //         permissions: [
      //           PERMISSIONS.WRITE_BANK_TRANSACTIONS
      //         ]
      //       }
      //     }
      //   ]
      // },
      {
        path: 'bankBalances',
        name: 'Bank Balances',
        component: BankBalances,
        meta: {
          permissions: [
            PERMISSIONS.READ_BANK_TRANSACTIONS
          ]
        },
        children: [
          {
            path: 'add',
            name: 'Record Bank Balance',
            component: AddBankBalance,
            meta: {
              permissions: [
                PERMISSIONS.WRITE_BANK_TRANSACTIONS
              ]
            }
          }
        ]
      },
      {
        path: 'reconcilliation',
        name: 'Reconcilliation',
        component: Reconcilliation,
        meta: {
          permissions: [
            // PERMISSIONS.READ_AUDIT_TRAIL
          ]
        }
      },
      {
        path: 'auditTrail',
        name: 'Audit Trail',
        component: AuditTrail,
        meta: {
          permissions: [
            PERMISSIONS.READ_AUDIT_TRAIL
          ]
        }
      },
      {
        path: 'userAccess',
        name: 'User Access',
        redirect: '/userAccess/users',
        component: UserAccess,
        meta: {
          permissions: [
            PERMISSIONS.READ_STAFF
          ]
        },
        children: [
          {
            path: 'users',
            name: 'Staff Users',
            component: StaffUsers,
            meta: {
              permissions: [
                PERMISSIONS.READ_STAFF
              ]
            },
            children: [
              {
                path: 'add',
                name: 'Register Staff User',
                component: AddStaffUser,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_STAFF
                  ]
                }
              },
              {
                path: ':staffUserId/edit',
                name: 'Edit Staff User',
                component: EditStaffUser,
                props: true,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_STAFF
                  ]
                }
              }
            ]
          },
          {
            path: 'roles',
            name: 'Roles',
            component: Roles,
            meta: {
              permissions: [
                PERMISSIONS.READ_ROLES
              ]
            },
            children: [
              {
                path: 'add',
                name: 'Create Role',
                component: AddRole,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_ROLES
                  ]
                }
              },
              {
                path: ':roleId/edit',
                name: 'Edit Role',
                component: EditRole,
                props: true,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_ROLES
                  ]
                }
              },
              {
                path: ':roleId/managePermissions',
                name: 'Manage Permissions',
                component: ManagePermissions,
                props: true,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_ROLES
                  ]
                }
              },
              {
                path: ':roleId/delete',
                name: 'Delete Role',
                component: DeleteRole,
                props: true,
                meta: {
                  permissions: [
                    PERMISSIONS.WRITE_ROLES
                  ]
                }
              },
            ]
          }
        ]
      },
      {
        path: 'reminders',
        name: 'Reminders',
        component: RouterView,
        redirect: 'reminders/list',
        children: [
          {
            path: 'list',
            name: 'List',
            component: Reminders,
            children: [
              {
                path: ':reminderId/delete',
                name: 'ConfirmDelete',
                props: true,
                component: ConfirmDeleteReminder,
              }
            ]
          }, 
          {
            path: 'add',
            name: 'Add',
            component: AddReminder
          },
          {
            path: ':reminderId/edit',
            name: 'Edit',
            props: true,
            component: EditReminder,
          }   
        ],
        meta: {
          permissions: []
        }
      },
      {
        path: '/403',
        name: 'Not Allowed',
        component: NotAllowed
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/change-password',
    name: 'Change Password',
    component: ChangePassword
  },
  {
    path: '/verifyAccount/:verificationToken',
    name: 'Verify Account',
    component: VerifyAccount,
    props: true,
  },
  {
    path: '/not-verified',
    name: 'Not Verified',
    component: NotVerified
  },
  {
    path: '/role-not-approved',
    name: 'Role Not Approved',
    component: RoleNotApproved
  }
]
